import { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import AlwaysOnRateOptionMobile from '../AlwaysOnRateOptionMobile'
import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane'
import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'

const OptionsContainer = styled.div`
  padding: ${rem(12)} ${rem(20)};
  background-color: ${props => props.theme.palette.neutral.default.eight};
`

interface Props {
  offer: App.Offer
  airports: Array<App.Airport>
  packageViews: Array<App.OfferPackageOptionView>
}

function AlwaysOnPackageOptionsModalTab(props: Props) {
  const { offer, airports, packageViews } = props
  const intl = useIntl()

  const destinationAirport = useMemo(() => airports.find(({ code }) => code === offer.flightDestinationPort), [airports, offer.flightDestinationPort])

  return (
    <Pane background="neutral-six">
      <Group direction="vertical" gap={8}>
        {packageViews.length > 1 && (
          <OptionsContainer>
            <BodyText variant="small" colour="neutral-three">{intl.formatMessage({
              id: 'dOAmoGcLQFKTmWnd6VsY',
              defaultMessage: '{count, plural, one {# package option} other {# package options}} available',
              description: 'Count of available package options for mobile booking',
            }, { count: packageViews.length })}
            </BodyText>
          </OptionsContainer>
        )}
        {packageViews.map((view, index) => <Pane key={view.package.uniqueKey}>
          <AlwaysOnRateOptionMobile
            offer={offer}
            optionNumber={index + 1}
            packageView={view}
            flightDestination={destinationAirport}
            showOptionLabel={packageViews.length > 1}
          />
        </Pane>)}
      </Group>
    </Pane>
  )
}

export default withOfferPageAndReduxState((state, appState) => {
  return {
    offer: state.offer,
    airports: appState.geo.airports,
  }
}, AlwaysOnPackageOptionsModalTab)
